var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",style:(_vm.style),attrs:{"width":"1","height":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }